(function () {
  var IST_OFFSET = '+05:30';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function parseDateTime(value) {
    if (!value) return null;

    var normalized = value.trim().replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) {
      normalized += ':00';
    }

    if (!/[zZ]|[+-]\d{2}:\d{2}$/.test(normalized)) {
      normalized += IST_OFFSET;
    }

    var date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function formatRemaining(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function isDesignMode() {
    return Boolean(window.Shopify && Shopify.designMode);
  }

  function isWithinSchedule(now, startDate, endDate) {
    if (startDate && now < startDate.getTime()) return false;
    if (endDate && now >= endDate.getTime()) return false;
    return true;
  }

  function initTimer(timer) {
    if (timer.dataset.pdpTimerInitialized === 'true') return;
    timer.dataset.pdpTimerInitialized = 'true';

    var display = timer.querySelector('[data-pdp-timer-display]');
    if (!display) return;

    var hideOutsideSchedule = timer.getAttribute('data-hide-outside-schedule') === 'true';
    var designMode = isDesignMode();
    var startDate = parseDateTime(timer.getAttribute('data-start-datetime') || '');
    var endDate = parseDateTime(timer.getAttribute('data-end-datetime') || '');

    function tick() {
      var now = Date.now();
      var active = designMode || !hideOutsideSchedule || isWithinSchedule(now, startDate, endDate);

      if (hideOutsideSchedule) {
        if (designMode || active) {
          timer.classList.remove('pdp-timer--pending');
          timer.style.display = '';
        } else {
          timer.classList.add('pdp-timer--pending');
          timer.style.display = 'none';
        }
      }

      if (!active) return;

      if (!endDate) {
        display.textContent = '00:00:00';
        return;
      }

      if (startDate && now < startDate.getTime()) {
        display.textContent = '00:00:00';
        return;
      }

      display.textContent = formatRemaining(endDate.getTime() - now);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-pdp-timer]').forEach(initTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
